import { get, post } from "./apiClient";
import { uriWithQueryStringParams } from "../utils/urlUtils";

export default {
  async getObservers(facilityId) {
    return await get(uriWithQueryStringParams("observers", { facilityId }));
  },

  async getObserverData(observerId, facilityId) {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);

    // Format as local YYYY-MM-DD (no UTC timezone shift)
    const pad = (n) => String(n).padStart(2, "0");
    const observationStartDate = `${start.getFullYear()}-${pad(
      start.getMonth() + 1
    )}-${pad(start.getDate())}`;

    return await get(
      uriWithQueryStringParams("observation/observerData", {
        observerId,
        facilityId,
        observationStartDate
      })
    );
  },

  async keepAlive() {
    return await get("observation");
  },

  async submitSession(session) {
    return await post("observation/session", session);
  }
};
